export { default } from './H2'


// WEBPACK FOOTER //
// ./src/components/H2/index.js